import {articleRepository} from '../actions/articleActions';
import type {Article} from '../types/article';

interface ArticleLoaderArgs {
  params: {
    section?: string;
    slug?: string;
  };
}

export interface ArticleRouteData {
  article: Article;
}

export const articleLoader = async ({params}: ArticleLoaderArgs): Promise<ArticleRouteData> => {
  const {section, slug} = params;
  if(!section || !slug) throw new Response('Article route is incomplete.', {status: 404});

  const article = await articleRepository.getByRoute(section, slug);
  if(!article) throw new Response('Article not found.', {status: 404});

  return {article};
};
